<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
		<v-col class="pa-0">

            <v-card class="flex pa-0 background-2 round-card">
			    <v-card-title class="pa-3">
    				<p class="pl-3">{{ title }}</p>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>

                           
			    </v-card-title>
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        v-if="newFieldsset && newFieldsset.fields"
                        :fieldsset.sync="newFieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                        @loaded="checkDefaultInput"
                    ></fields-generator>

                    <v-row class="ma-0">
                        <v-subheader>Distribuzione Importo</v-subheader>
                    </v-row>
                    <v-row class="pb-2 ma-0 px-3">
                        <v-btn 
                            :disabled="disableDistribution"
                            @click="distributePayment"
                            outlined>
                            Distribuisci
                        </v-btn>
                        <span class="caption grey--text ml-3 align-self-center">
                            {{ selected.length ? 'Solo sulle righe selezionate' : 'Usa anche note di credito ed eccedenze, solo per quanto serve oltre l\'importo; seleziona le righe per lavorare solo su quelle' }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-text-field class=" font-weight-regular"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            background-color="background-2"
                            outlined
                            dense               
                        ></v-text-field>                    
                    </v-row>

			        <v-divider></v-divider>

                    <v-data-table
                        :items="items"
                        :headers="headers"
                        :loading="loading"
			            v-model="selected"
                        :search="search"
                        show-select
                        class="background-2 round-card pb-0"
			            :mobile-breakpoint="0"
                        ref="deadlines"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50, -1],
                            showFirstLastPage: true
                        }">

                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

                        <template v-slot:item="{item, select, isSelected, isExpanded, headers, index}">
                            <tr class="cursor-pointer">
                                <template v-for="(header, h) in headers">
                                    <td :key="h" v-if="header.value == 'data-table-select'">
                                        <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                                    </td>     
                                    <td v-else-if="header.value === 'deadline_type'" :key="h" :class="'text-'+(header.align?header.align:'left')">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" :color="$eventBusUtility.deadlineTypeColor(item.deadline_type)">mdi-cash-multiple</v-icon>
                                            </template>
                                            <span v-ripple>
                                                {{ item.deadline_type_text }}
                                            </span>
                                        </v-tooltip>
                                    </td>
                                    
                                    <td v-else-if="header.type === 'general_type'" :key="h">
                                        <template v-if="item[header.value] in infoData['general_types'][header.value]">

                                            <template v-if="header.subtype == 'chip'">

                                                <v-chip v-if="item[header.value] && infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color" :class="header.subtype" :text-color="$eventBusUtility.lightOrDark(infoDataGeneralType(header.value, item).color) == 'dark' ? 'white' : 'black'" small :color="infoDataGeneralType(header.value, item).color">{{ infoData['general_types'][header.value][item[header.value]].text }}</v-chip>
                                                
                                                <v-chip v-else-if="item[header.value]" :class="header.subtype" text-color="white" small>{{ infoData['general_types'][header.value][item[header.value]].text }}</v-chip>
                                            </template>
                                            <template v-else-if="header.subtype == 'squared-chip'">
                                                <template v-if="infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color">
                                                    <div class="squared-chip" :style="{'color': infoDataGeneralType(header.value, item).color}">
                                                        {{ infoData['general_types'][header.value][item[header.value]].text }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="squared-chip">
                                                        {{ infoData['general_types'][header.value][item[header.value]].text }}
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else-if="header.subtype == 'squared-chip-filled'">
                                                <template v-if="infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color">
                                                    <div class="squared-chip-filled" :style="{'background-color': infoDataGeneralType(header.value, item).color}">
                                                        <span :style="{'color': $eventBusUtility.lightOrDark(infoDataGeneralType(header.value, item).color) == 'dark' ? 'white' : 'black'}">
                                                            {{ infoData['general_types'][header.value][item[header.value]].text }}
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="squared-chip-filled">
                                                        {{ infoData['general_types'][header.value][item[header.value]].text }}
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                    </td>                                    
                                    <td v-else-if="header.type === 'currency'" :key="h" :class="header.class">
                                        {{ item[header.value] | currency(2) }}
                                    </td>
                                    <td v-else-if="header.type == 'date'" :key="h">
                                        {{ item[header.value] | date }}
                                    </td>
                                    <td v-else-if="'text_value' in header" :key="h">
                                        {{ item[header.text_value] }}
                                    </td>
                                    <td v-else-if="header.type == 'chip'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
                                        <v-chip small v-if="item[header.value]">
                                            <template v-if="header.customfield">{{ getChipText(header, item[header.value]) }}</template>
                                            <template v-else>{{ item[header.value] }}</template>
                                        </v-chip>
                                    </td>

                                    <td v-else-if="header.value == 'payment_amount'" style="min-width: 170px; /*padding-top: 24px;*/" :class="'text-xs-'+header.align" :key="h">
                                        <v-text-field
                                            label="Importo"
                                            v-model.number="item['payment_amount']"
                                            :prefix="isCompensation(item) ? '−' : ''"
                                            :title="isCompensation(item) ? 'Compensazione: sottrae dall\'importo del pagamento' : ''"
                                            type="number"
                                            outlined
                                            single-line
                                            dense
                                            hide-details
                                            clearable
                                            @click:clear="clearPaymentAmount(item)"
                                            data-vv-as="Importo"
                                            v-validate="''"
                                            :data-vv-name="'Importo_' + index"
                                            :error-messages="errors.collect('Importo_' + index)">
                                        </v-text-field>
                                    </td>
                                    <td v-else-if="header.value == 'discount'" style="/*padding-top: 24px;*/" :class="'text-xs-center'" :key="h">
                                        <div v-if="item.deadline_condition == 'overpayment'">

                                        </div>                                         
                                        <v-checkbox v-else
                                            v-model="item['discount']"
                                            @change="updateDiscount(item)"
                                            class="ma-auto discount-checkbox"
                                            hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td v-else-if="header.value == 'payment_discount'" style="min-width: 100px; /*padding-top: 24px;*/" :class="'text-xs-'+header.align" :key="h">
                                        <div v-if="item.deadline_condition == 'overpayment'">

                                        </div>
                                        <v-text-field v-else
                                            label="Abbuono"
                                            v-model.number="item.payment_discount"
                                            type="number"
                                            outlined
                                            dense
                                            readonly
                                            hide-details
                                            data-vv-as="Abbuono"
                                            :data-vv-name="'Abbuono' + item.id"
                                            :error-messages="errors.collect('Abbuono' + item.id)">
                                        </v-text-field>
                                    </td>

                                    <td v-else :key="h">
                                        {{ header.type}}
                                        {{ item[header.value] }}
                                    </td>
                                </template>
                            </tr>
                        </template>

                        <template v-slot:footer.page-text="{ pageStart, pageStop }">
                            Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                        </template>                        
                    </v-data-table>


                    <v-row class="ma-0" justify="center">
                        <v-col class="pa-0" lg="3" md="3" sm="6">
                            <v-list two-line class="background-2 w100p">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="green">mdi-cash-check</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Totale Importo Scadenze</v-list-item-title>
                                        <v-list-item-subtitle>{{ deadlinesTotal | currency(2) }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                
                        <v-col class="pa-0" lg="3" md="3" sm="6">
                            <v-list two-line class="background-2 w100p">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-cash-remove</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ amountLabel }} Assegnato</v-list-item-title>
                                        <v-list-item-subtitle>{{ assignedPayment | currency(2) }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                
                        <v-col class="pa-0" lg="3" md="3" sm="6">
                            <v-list two-line class="background-2 w100p">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="red">mdi-cash-clock</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ amountLabel }} Residuo (Eccedenza)</v-list-item-title>
                                        <v-list-item-subtitle>{{ paymentBalance | currency(2) }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>
                    </v-row>


                </v-container>

                <v-dialog v-model="confirmModel" persistent max-width="600">
                    <v-card class="background-2 round-card">
                        <v-card-title primary-title class="subtitle-1 background-2">Attenzione</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                            L'importo inserito non è stato interamente assegnato. Se continuerai l'importo rimanente verrà associato a una nuova scadenza e potrai riassegnarlo in seguito. Vuoi continuare?
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="confirmModel = false">Annulla</v-btn>
                            <v-btn color="info" text @click="storeModel">Procedi</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-fab-transition>
                            <v-btn
                                v-on="{ ...tooltip }"
                                @click.native="createModel"
                                :loading="saved"
                                color="primary"
                                dark
                                fixed
                                bottom
                                right
                                fab>
                                <v-icon>{{ id ? 'mdi-sync' : 'mdi-check'}}</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </template>
                    <span>{{ id ? 'Aggiorna' : 'Crea' }}</span>
                </v-tooltip>
            </v-card>
        </v-col>       
    </v-row>
</template>

<script>
    import FormsMixin from '@/mixins/FormsMixin'

    export default {
        name: 'create-payment',
        props: {
            id: Number,
            defaultInput: Object,
            modelDef: { type: String, default: 'companypayments' },
            deadlinesModelDef: { type: String, default: 'companydeadlines' },
        },
        mixins: [FormsMixin],
        data() {
            return {
			    search: '',
				items: [],
                editItemsClone: [],
				loading: false,
                headers: [],
                fieldsset: {},
                model: {},
                info: {},
                infoData: {},
                totalItems: 0,
				selected: [],
                fab: false,
                confirmModel: false,
                saved: false,
                // partenza del nuovo pagamento, solo in creazione: una scadenza (tab
                // Pagamenti della scadenza) o un documento (tab Pagamenti del documento).
                // Serve solo a ricavare l'azienda: importo e distribuzione restano
                // all'utente, come nel pagamento normale
                preselectDeadlineId: null,
                preselectDocumentId: null,
                // defaultInput effettivo del form: senza deadline_id/document_id e con
                // il company_id ricavato, cosi' checkDefaultInput precarica l'opzione
                // della select asincrona (altrimenti il valore c'e' ma non si vede)
                resolvedDefaultInput: {},
            }
        },

        computed: {

            // con i segni, come Pagamento Assegnato: note di credito ed eccedenze
            // (compensazioni) sottraggono
            deadlinesTotal() {
                return this.items.reduce((total, item) => {
                    const remaining = this.remainingToPayOnItem(item)
                    return total + (this.isCompensation(item) ? -remaining : remaining)
                }, 0)
            },

            // netto: le compensazioni sottraggono
            assignedPayment() {
                return this.items.reduce((total, item) => {
                    const amount = Number(item.payment_amount) || 0
                    // valore assoluto: regge anche la quota negativa dei dati storici
                    return total + (this.isCompensation(item) ? -Math.abs(amount) : amount)
                }, 0)
            },

            paymentBalance() {
                if(this.model.amount == undefined) {
                    return 0
                }
                const balance = this.formatAmount(this.model.amount - this.assignedPayment);
                // Se il balance è esattamente 0 o un numero molto piccolo (< 0.01), ritorna 0
                return balance < 0.01 ? 0 : balance;
            },

            title() {
                return this.id ? 'Modifica Pagamento' : 'Crea Pagamento'
            },

			infoDataGeneralType(headerValue, item) {
				return (headerValue, item) => {
					if(this.infoData['general_types'] && this.infoData['general_types'][headerValue] && this.infoData['general_types'][headerValue][item[headerValue]] && this.infoData['general_types'][headerValue][item[headerValue]]['extra_fields']) {
						return this.infoData['general_types'][headerValue][item[headerValue]]['extra_fields']
					} else return null
				}
			},

            // Lato cliente si incassano rate di credito, lato fornitore si pagano
            // rate di debito: le rate dell'altro tipo (note di credito) sono
            // compensazioni e contano in negativo, come Payment::allocatedAmount().
            // Su un rimborso il denaro va nel verso opposto: sono le note di
            // credito a essere saldate, non a compensare.
            mainDeadlineType() {
                const type = this.deadlinesModelDef === 'supplierdeadlines' ? 'debit' : 'credit'
                if (!this.isRefund) {
                    return type
                }
                return type === 'credit' ? 'debit' : 'credit'
            },

            isRefund() {
                return !!this.model.refund && this.model.refund !== '0'
            },

            // etichetta del denaro del pagamento, diversa per rimborsi e per lato
            amountLabel() {
                if (this.isRefund) {
                    return this.deadlinesModelDef === 'supplierdeadlines' ? 'Rimborso Ricevuto' : 'Rimborso'
                }
                return 'Pagamento'
            },

            // compensazioni gia' inserite: denaro in piu' da ripartire sulle altre rate
            compensationsEntered() {
                return this.items.reduce((total, item) => {
                    return total + (this.isCompensation(item) ? Math.abs(Number(item.payment_amount) || 0) : 0)
                }, 0)
            },

            disableDistribution() {
                if (!this.model.company_id) {
                    return true
                }
                if (this.formatAmount(this.model.amount) > 0) {
                    return false
                }
                // importo 0 o vuoto, sulle righe selezionate o su tutte: basta una rata da
                // coprire (con credito la compensa, senza credito la salda)
                const selectedIds = new Set(this.selected.map(item => item.id))
                const inScope = item => selectedIds.size === 0 || selectedIds.has(item.id)
                const toCover = this.items.filter(item => inScope(item) && !this.isCompensation(item)).reduce((total, item) => total + this.remainingToPayOnItem(item), 0)
                return !(toCover > 0)
            },

            deadlinePayments() {
                // niente righe a zero senza abbuono: in creazione sarebbero quote vuote,
                // in modifica toglierle scollega la rata dal pagamento
                return this.items.filter(item => {
                    if (item.payment_amount === '' || item.payment_amount === undefined || item.payment_amount === null) {
                        return false
                    }
                    return Number(item.payment_amount) !== 0 || Number(item.payment_discount) > 0
                }).map(item => {
                    // niente payment_remittance: item e' la rata, e il suo flag "in
                    // distinta" marcava come incasso da distinta una quota registrata a mano
                    let deadlinepayment = {
                        deadline_id: item.id,
                        payment_amount: parseFloat(item.payment_amount),
                        payment_discount: item.payment_discount,
                    }
                    if(this.id) {
                        deadlinepayment.payment_id = this.id
                        deadlinepayment.id = item.deadlinepayment_id
                    }
                    return deadlinepayment
                })
            },

            totalPaymentAmount() {
                return this.assignedPayment.toFixed(2)
            },

            newFieldsset() {
                // Prima della risposta di /edit (o /create) il fieldset non ha ancora
                // i campi: un render anticipato mandava in errore la pagina, che
                // restava vuota (visto in modifica pagamento aperta da URL diretto)
                if (!this.fieldsset || !Array.isArray(this.fieldsset.fields)) {
                    return this.fieldsset
                }
                return {
                    model_name: this.fieldsset.model_name,
                    modelDef: this.fieldsset.modelDef,
                    fields: this.fieldsset.fields.map(field => {
                        if(field.key === 'company_id') {
                            return {
                                ...field,
                                disabled: this.id ? true : false
                            }
                        }
                        if(field.key === 'amount') {
                            let totalPaymentAmount = this.totalPaymentAmount
                            if(totalPaymentAmount > 0) {
                                return {
                                    ...field,
                                    validations: field.validations + '|min_value:' + (this.totalPaymentAmount)
                                }
                            } else {
                                return {
                                    ...field,
                                    validations: 'required|decimal:2'
                                }
                            }
                        }
                        return field
                    })
                }
            }

        },

        watch: {
            'model.company_id': {
                handler() {
                    if (this.model.company_id) {
                        this.getData()
                    } else {
                        this.items = []
                    }
                },
            },
        },

        methods: {
            // il default arriva come stringa (es. '0'): per le select va riportato al
            // tipo del valore dell'opzione, altrimenti la select non lo riconosce
            defaultValueFor(field) {
                if(field.options && field.options.length) {
                    const option = field.options.find(o => String(o.value) === String(field.default))
                    if(option) return option.value
                }
                return field.default
            },
            // Compensazioni: le rate di tipo opposto al movimento, come
            // Payment::allocatedAmount(). Su un incasso sono le note di credito e
            // le eccedenze (credito utilizzabile); su un rimborso sono le fatture,
            // mentre note di credito ed eccedenze diventano cio' che si salda.
            isCompensation(item) {
                return !!item.type && item.type !== this.mainDeadlineType
            },

            formatAmount(value) {
                return parseFloat(parseFloat(value || 0).toFixed(2));
            },

            // In modifica item.paid arriva dal backend e include gia' l'allocazione
            // che QUESTO pagamento ha su quella rata (le deadline_payment gia'
            // salvate): va scorporata, altrimenti il denaro del pagamento viene
            // contato come se appartenesse a qualcun altro e la rata sembra piu'
            // piena di quanto sia. La fonte e' model.deadlinepayments, il dato
            // originale restituito da /edit e mai riscritto dai bottoni di questa
            // pagina (a differenza di items[].payment_amount, che "Distribuisci"
            // sovrascrive). In creazione non c'e' un pagamento da scorporare.
            ownAllocationOnDeadline(deadlineId) {
                if (!this.id || !this.model.deadlinepayments) {
                    return 0
                }
                let deadlinepayment = this.model.deadlinepayments.find(dp => dp.deadline_id == deadlineId)
                return deadlinepayment ? this.formatAmount(deadlinepayment.amount) : 0
            },

            // valori assoluti: eccedenze (importo negativo) e quote storiche negative
            // delle note di credito
            remainingToPayOnItem(item) {
                const ownAllocation = Math.abs(this.ownAllocationOnDeadline(item.id))
                return this.formatAmount(Math.max(Math.abs(Number(item.amount) || 0) - (Math.abs(Number(item.paid) || 0) - ownAllocation), 0))
            },

            // Rate dalla scadenza piu' vecchia alla piu' recente: e' l'ordine in cui
            // "Distribuisci" assegna l'importo e quello con cui la tabella si apre
            // (il backend ordina per id decrescente, cioe' le rate piu' nuove prima)
            sortByExpiration(rows) {
                return rows.slice().sort((a, b) => {
                    const byDate = String(a.expiration_date || '').localeCompare(String(b.expiration_date || ''))
                    return byDate !== 0 ? byDate : (Number(a.id) || 0) - (Number(b.id) || 0)
                })
            },

            // Distribuisci:
            // - con righe selezionate lavora solo su quelle (le altre si svuotano);
            // - senza selezione su tutte le righe;
            // - importo piu' credito disponibile (note di credito ed eccedenze) coprono
            //   le rate dalla scadenza piu' vecchia, anche con importo maggiore di zero.
            // Il credito si preleva solo per quanto serve oltre l'importo: se l'importo
            // basta, o non c'e' nulla da coprire, resta intatto. L'importo scritto
            // dall'utente non cambia.
            distributePayment() {
                const selectedIds = new Set(this.selected.map(item => item.id))
                const onlySelected = selectedIds.size > 0
                const inScope = item => !onlySelected || selectedIds.has(item.id)
                const emptyRow = item => ({ ...item, payment_amount: null, discount: false, payment_discount: null })
                const amount = this.formatAmount(this.model.amount)
                // il credito nell'ambito si usa sempre (prima valeva solo con selezione
                // o importo 0): le compensazioni scritte a mano vengono ricalcolate
                const autoCredit = true
                const amountWasEmpty = this.model.amount === '' || this.model.amount === null || this.model.amount === undefined

                // importo vuoto: la compensazione e' un pagamento a zero
                if (autoCredit && amountWasEmpty) {
                    this.$set(this.model, 'amount', 0)
                }

                this.items = this.sortByExpiration(this.items)
                if (autoCredit) {
                    this.items.forEach((item, index) => {
                        if (!inScope(item) || this.isCompensation(item)) {
                            this.$set(this.items, index, emptyRow(item))
                        }
                    })
                }

                // credito disponibile: in automatico quello delle compensazioni nell'ambito,
                // altrimenti quello gia' scritto a mano sulle righe
                const credit = autoCredit
                    ? this.items.filter(item => inScope(item) && this.isCompensation(item)).reduce((total, item) => total + this.remainingToPayOnItem(item), 0)
                    : this.compensationsEntered

                // senza credito nell'ambito e importo non positivo:
                // - importo 0 scritto dall'utente: non c'e' nulla da distribuire, le rate
                //   restano a zero e l'importo non si tocca;
                // - campo vuoto: le rate si riempiono con il loro residuo e l'importo
                //   diventa il totale assegnato
                if (autoCredit && amount <= 0 && credit <= 0) {
                    let total = 0
                    this.items.forEach((item, index) => {
                        if (this.isCompensation(item) || !inScope(item)) {
                            return
                        }
                        const paymentAmount = amountWasEmpty ? this.remainingToPayOnItem(item) : 0
                        this.$set(this.items, index, { ...emptyRow(item), payment_amount: paymentAmount > 0 ? paymentAmount.toFixed(2) : null })
                        total = this.formatAmount(total + paymentAmount)
                    })
                    if (amountWasEmpty) {
                        this.$set(this.model, 'amount', total.toFixed(2))
                    }
                    return
                }

                let budget = this.formatAmount(amount + credit)
                let assigned = 0
                this.items.forEach((item, index) => {
                    if (this.isCompensation(item) || !inScope(item)) {
                        return
                    }
                    const paymentAmount = budget > 0 ? this.formatAmount(Math.min(this.remainingToPayOnItem(item), budget)) : 0
                    this.$set(this.items, index, { ...emptyRow(item), payment_amount: paymentAmount > 0 ? paymentAmount.toFixed(2) : null })
                    budget = this.formatAmount(budget - paymentAmount)
                    assigned = this.formatAmount(assigned + paymentAmount)
                })

                if (autoCredit) {
                    let creditNeeded = this.formatAmount(Math.max(assigned - amount, 0))
                    this.items.forEach((item, index) => {
                        if (!inScope(item) || !this.isCompensation(item)) {
                            return
                        }
                        const used = creditNeeded > 0 ? this.formatAmount(Math.min(this.remainingToPayOnItem(item), creditNeeded)) : 0
                        this.$set(this.items, index, { ...emptyRow(item), payment_amount: used > 0 ? used.toFixed(2) : null })
                        creditNeeded = this.formatAmount(creditNeeded - used)
                    })
                }
            },

            updateDiscount(item) {
                if(item.discount) {
                    if(this.id) {

                        let editItem = this.editItemsClone.find(editItem => editItem.id == item.id)
                        if(editItem && editItem.payment_amount == item.payment_amount) {
                            this.$set(item, 'payment_discount', this.roundNumber(item.amount - editItem.payment_amount))
                        } else {
                            this.$set(item, 'payment_discount', this.roundNumber(item.amount - item.paid - item.payment_amount))
                        }
                    } else {
                        this.$set(item, 'payment_discount', this.roundNumber(item.amount - item.paid - item.payment_amount))
                    }
                } else {
                    this.$set(item, 'payment_discount', 0)
                }
            },

            roundNumber(num) {
                return (Math.round(num * 100 + Number.EPSILON ) / 100).toFixed(2)
            },

            getData() {
                this.loading = true
                let params = {
                    paginate: false,
                    sortBy: ['expiration_date'],
                    sortDesc: [false],
                    subFilters: {
                        companies: this.model.company_id,
                    }
                }

                if(this.id) {
                    // in modifica: rate aperte piu' quelle collegate a questo pagamento
                    // (niente rate chiuse estranee, che Distribuisci riempirebbe per prime)
                    params.subFilters.deadlinesForPayment = this.id
                } else {
                    params.subFilters.deadlinesNotClosed = true
                }

                this.axios.post(this.deadlinesModelDef + '-filters', params).then(response => {
                    this.items = this.sortByExpiration(response.data.data.data)
                    this.otherdata = response.data.data.otherData
                    this.selected = []
                    this.totalItems = response.data.data.data.length
                    this.loading = false
                    
                    this.setPaymentDeadlineInEdit()
             
                }, response => {
                    this.loading = false
                })
            },

            // Azienda (o fornitore) da cui parte il nuovo pagamento, letta dalla
            // scadenza o dalle rate del documento; null se non ricavabile: il form
            // si apre comunque vuoto
            preselectedCompanyId() {
                if (this.id) {
                    return Promise.resolve(null)
                }
                if (this.preselectDeadlineId) {
                    return this.axios.get(this.deadlinesModelDef + '/' + this.preselectDeadlineId).then(response => {
                        const deadline = response.data.models && response.data.models.deadline
                        return deadline && deadline.company_id ? deadline.company_id : null
                    }, () => null)
                }
                if (this.preselectDocumentId) {
                    return this.axios.post(this.deadlinesModelDef + '-filters', {
                        paginate: false,
                        subFilters: { documents: this.preselectDocumentId },
                    }).then(response => {
                        const rows = (response.data.data && response.data.data.data) || []
                        return rows.length && rows[0].company_id ? rows[0].company_id : null
                    }, () => null)
                }
                return Promise.resolve(null)
            },

            checkDefaultInput() {
                // stesso helper degli altri form, con il defaultInput risolto al posto della prop
                this.$eventBusUtility.checkDefaultInput({
                    defaultInput: this.resolvedDefaultInput,
                    fieldsset: this.fieldsset,
                    model: this.model,
                    $refs: this.$refs,
                }, 'model')
            },

            clearPaymentAmount(item) {
                this.$set(item, 'payment_amount', null)
                this.$set(item, 'payment_discount', null)
                this.$set(item, 'discount', false)
            },

            setPaymentDeadlineInEdit() {
                if(this.id) {
                    _.forEach(this.model.deadlinepayments, (deadlinepayment, index) => {
                        _.forEach(this.items, (item2, index2) => {
                            if(item2.id == deadlinepayment.deadline_id) {
                                this.$set(this.items, index2, {
                                    ...item2,
                                    deadlinepayment_id: deadlinepayment.id ? deadlinepayment.id : null,
                                    payment_amount: deadlinepayment.amount,
                                    payment_discount: deadlinepayment.discount,
                                    discount: deadlinepayment.discount > 0 ? true : false,
                                    payment_remittance: deadlinepayment.payment_remittance
                                })
                            }
                        })
                    })
                    this.editItemsClone = _.cloneDeep(this.items)
                }
            },

            createModel() {
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }    
                    // compensazioni oltre le rate: il credito finirebbe solo in una nuova eccedenza
                    if (this.assignedPayment < -0.005) {
                        this.$store.commit('setSnackbar', { timeout: 8000, text: 'Le compensazioni (note di credito ed eccedenze) superano gli importi assegnati alle rate: riducile o assegna le rate da coprire.', value: true, color: 'error' })
                        return
                    }
                    if(this.paymentBalance > 0) {
                        this.confirmModel = true
                    } else {
                        this.storeModel()
                    }
                }).catch((e) => {
                    this.saved = false
                })                           
            },

            storeModel() {
                if(this.id) {

                    this.saved = true
                    delete this.model.deadlinepayments

                    let data = {
                        payment: this.model,
                        deadline_payment: this.deadlinePayments
                    }

                    this.axios.put(this.modelDef + '/' + this.id, data).then(response => {
                        // get body data
                        this.$emit('update:model', {})
                        this.$eventBusUtility.$emit('modelCreated', response.data.id)
                        this.saved = false
                        this.$store.commit('setModelEdited', false)

                        this.$router.push({ name: this.modelDef + '-index' })

                    }, response => {
                        // error callback
                        this.saved = false
                    })                   

                } else {

                    this.saved = true

                    let data = {
                        payment: this.model,
                        deadline_payment: this.deadlinePayments
                    }

                    this.axios.post(this.modelDef, data).then(response => {
                        // get body data
                        this.$emit('update:model', {})
                        this.$eventBusUtility.$emit('modelCreated', response.data.id)
                        this.saved = false
                        this.$store.commit('setModelEdited', false)

                        this.$router.push({ name: this.modelDef + '-index' })

                    }, response => {
                        // error callback
                        this.saved = false
                    })
                }
            },
        },
        
        created() {
            if(this.id) {
                this.axios.get(this.modelDef + '/' + this.id + '/edit').then(response => {
                    // get body data
                    this.model = response.data.model
                    this.fieldsset = response.data.fields
                    this.headers = response.data.info.fieldDefs
                    this.infoData = response.data.info

                    this.setPaymentDeadlineInEdit()

                    // in modifica il default vale solo per i campi senza valore: applicato
                    // sopra il modello azzerava la data (default "oggi") e il tipo movimento
                    _.forEach(this.fieldsset.fields, (value, key) => {
                        if(value.default && (this.model[value.key] === undefined || this.model[value.key] === null || this.model[value.key] === '')) {
                            this.$set(this.model, value.key, this.defaultValueFor(value))
                        }
                    })

                    this.resolvedDefaultInput = this.defaultInput || {}
                    _.forEach(this.defaultInput, (value, key) => {
                        this.$set(this.model, key, value)
                    })

                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })            
            } else {
                this.axios.get(this.modelDef + '/create').then(response => {
                    // deadline_id e document_id non sono campi del pagamento: indicano la
                    // scadenza o il documento da cui si parte. L'azienda (o il fornitore) va
                    // letta prima di costruire il form, come quando il company_id arriva gia'
                    // nel defaultInput: la select e' asincrona e un valore impostato dopo
                    // resterebbe senza etichetta
                    this.preselectDeadlineId = (this.defaultInput && this.defaultInput.deadline_id) || null
                    this.preselectDocumentId = (this.defaultInput && this.defaultInput.document_id) || null
                    this.preselectedCompanyId().then(companyId => {
                        this.fieldsset = response.data.fields
                        this.headers = response.data.info.fieldDefs
                        this.infoData = response.data.info

                        _.forEach(this.fieldsset.fields, (value, key) => {
                            if(value.default) {
                                this.$set(this.model, value.key, this.defaultValueFor(value))
                            }
                        })

                        const resolved = {}
                        _.forEach(this.defaultInput, (value, key) => {
                            if (key !== 'deadline_id' && key !== 'document_id') {
                                resolved[key] = value
                            }
                        })
                        if (companyId && !resolved.company_id) {
                            resolved.company_id = companyId
                        }
                        this.resolvedDefaultInput = resolved
                        _.forEach(resolved, (value, key) => {
                            this.$set(this.model, key, value)
                        })

                        this.$store.commit('endProgress')
                    })

                }, response => {
                    // error callback
                })
            }
        },
    }
</script>
<style >
    .discount-checkbox .v-input--selection-controls__input {
        margin: auto !important;
    }
</style>
